module.exports = __webpack_public_path__ + "static/media/cycle-icon2.1508800d.svg";